import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import Routes from "routes";

export default class WantedLinks extends Component {
	render() {
		return (
			<Row {...this.props} className={ 'wanted-links ' + this.props.className}>
				<Col xs={12} sm={6}>
					<Link to={{ pathname: Routes.wanted, search: "?types=jet"}} className="btn">
						Jets Wanted
					</Link>
					<Link to={{ pathname: Routes.wanted, search: "?types=turboprop"}} className="btn">
						Turbo Props Wanted
					</Link>
					<Link to={{ pathname: Routes.wanted, search: "?types=single-piston"}} className="btn">
						Single Pistons Wanted
					</Link>
				</Col>
				<Col xs={12} sm={6}>
					<Link to={{ pathname: Routes.wanted, search: "?types=twin-piston"}} className="btn">
						Twin Pistons Wanted
					</Link>
					<Link to={{ pathname: Routes.wanted, search: "?types=helicopter"}} className="btn">
						Helicopters Wanted
					</Link>
					<Link to={Routes.wanted} className="btn">
						All Aircraft Wanted
					</Link>
				</Col>
			</Row>
		);
	}
}
